import React from 'react';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';

const RouteErrorBoundary = () => {
  return (
    <Card
      style={{
        width: '100vw',
        height: '100vh',
        border: 'none',
        boxShadow: 'none',
      }}
      title="Error"
      subTitle="An unexpected error has occurred"
    >
      <Button
        label="Go Home"
        icon="pi pi-home"
        onClick={() => {
          window.location.href = '/';
        }}
      />
    </Card>
  );
};

export default RouteErrorBoundary;
